/** Deduplicate the array based on object equality */
export const dedupe = <T>(arr: T[]): T[] => [...new Set(arr)]
